import { isArrayValid } from "../helpers/utility";
import BaseService from "./BaseService";
import { UpdateNameModel } from "../core/contracts/UpdateNameModel";

export default class DirectorShipService extends BaseService {
  async fetch(): Promise<string[]> {
    try {
      const APIResponse = await new BaseService(true).get<string[]>(
        "/core/InstallationGroup/GetDirectorShipList"
      );

      if (isArrayValid(APIResponse)) {
        return APIResponse.filter((x) => x);
      }

      return new Promise((_, rej) => rej(`Invalid response → ${APIResponse}`));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("DirectorShipService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async update(directorShipNameModel: UpdateNameModel): Promise<boolean> {
    try {
      return await new BaseService(true).post<boolean, UpdateNameModel>(
        "/core/InstallationGroup/UpdateDirectorShipName",
        directorShipNameModel
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("DirectorShipService -> update -> error", error);
      return Promise.reject(error);
    }
  }

  async count(directorShipName: string): Promise<number> {
    try {
      const APIResponse = await new BaseService(true).get<number>(
        `/core/InstallationGroup/CountDirectorShipName/${directorShipName}`
      );
      return APIResponse;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("DirectorShipService -> count -> error", error);
      return Promise.reject(error);
    }
  }
}
